import React from "react";
import s from "./Separator.module.scss";

const Separator = ({ mainClass, textClass, text, margin, dataTestid }) => {
  const noText = !(text !== undefined);
  return (
    <div style={{ margin: margin ?? "" }} className={`${mainClass ? mainClass : s.separator}`}>
      <span
        data-testid={dataTestid}
        className={`${textClass ? textClass : noText ? s.separator__noText : s.separator__text}`}
      >
        {text}
      </span>
    </div>
  );
};

export default Separator;
